import { render, staticRenderFns } from "./StakeCollapse.vue?vue&type=template&id=872c5fbe&scoped=true"
import script from "./StakeCollapse.vue?vue&type=script&lang=js"
export * from "./StakeCollapse.vue?vue&type=script&lang=js"
import style0 from "./StakeCollapse.vue?vue&type=style&index=0&id=872c5fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c5fbe",
  null
  
)

export default component.exports